import { CheckmarkFilled, CircleDash, ErrorFilled, InformationFilled, InProgress, WarningAltFilled } from '@carbon/icons-react';
import { cx } from '@/shared/lib/cx';
import s from './Feedback.module.css';

export type Tone = 'info' | 'success' | 'warning' | 'error';
export type PillTone = Tone | 'neutral' | 'progress';

const ICON_CLASS: Record<Tone, string | undefined> = {
  info: s.iconInfo,
  success: s.iconSuccess,
  warning: s.iconWarning,
  error: s.iconError,
};

/** Иконка статуса: цвет никогда не передаёт статус один (DESIGN.md, WCAG 1.4.1). */
export function StatusIcon({ tone, size = 20, className }: { tone: Tone; size?: 16 | 20; className?: string }) {
  const props = { size, className: cx(s.statusIcon, ICON_CLASS[tone], className), 'aria-hidden': true as const };
  switch (tone) {
    case 'success':
      return <CheckmarkFilled {...props} />;
    case 'warning':
      return <WarningAltFilled {...props} />;
    case 'error':
      return <ErrorFilled {...props} />;
    default:
      return <InformationFilled {...props} />;
  }
}

export function PillIcon({ tone }: { tone: PillTone }) {
  if (tone === 'neutral') return <CircleDash size={16} aria-hidden="true" />;
  if (tone === 'progress') return <InProgress size={16} aria-hidden="true" />;
  return <StatusIcon tone={tone} size={16} />;
}
